import { Participant } from '@app/models'

export const getIsB2BOrCurrentUserPrivateAdvertiser = (
  participants: Participant[] | undefined,
  currentUserId: number | string | undefined,
  isB2B: boolean
): boolean => {
  if (isB2B) {
    return true
  }

  const currentUserIdNumber =
    currentUserId !== undefined && currentUserId !== null
      ? Number(currentUserId)
      : undefined

  const currentUserParticipant = participants?.find(
    (participant) =>
      currentUserIdNumber !== undefined &&
      participant.userId === currentUserIdNumber
  )

  return Boolean(currentUserParticipant?.isPrivateAdvertiser)
}